import { useDeleteCustomerMutation } from "@common/api/customers"
import { handleError } from "@common/utils"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DeleteDialog } from "@/components/layout/list-table-menu"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute("/_layout/customer/delete/$customerId")({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "customer:delete", "/"),
  component: DeleteCustomerDialog,
})

function DeleteCustomerDialog(): React.ReactElement {
  const { customerId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const remove = useDeleteCustomerMutation()

  const close = () => navigate({ to: "/customer", search: true })

  return (
    <DeleteDialog
      noun="customer"
      pending={remove.isPending}
      onCancel={close}
      onConfirm={() =>
        remove.mutate(
          { customer_id: customerId },
          {
            onSuccess: () => {
              showToast("Deleted", "Customer deleted.", "success")
              close()
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
    />
  )
}
